module.exports = __webpack_public_path__ + "img/549.59fc7ee7.jpg";